import { MapPin, Building2 } from "lucide-react";
import { FadeUp, Eyebrow } from "./Reveal";
import { ROMA_QUARTIERI, ZONES } from "../constants";

const AreaCloud = ({ title, icon: Icon, accent, items, testId }) => (
  <div data-testid={testId}>
    <div className="flex items-center gap-3 mb-6">
      <Icon className="w-5 h-5" style={{ color: accent }} />
      <h3
        className="font-mono-tech text-xs uppercase tracking-[0.25em]"
        style={{ color: accent }}
      >
        {title}
      </h3>
      <span className="h-px flex-1 bg-white/10" />
      <span className="font-mono-tech text-xs text-[#94A3B8]">
        {items.length} zone
      </span>
    </div>
    <div className="flex flex-wrap gap-2.5">
      {items.map((zone) => (
        <span
          key={zone}
          data-testid={`${testId}-${zone.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className="rounded-full border border-white/10 px-4 py-2 text-sm text-[#F1F5F9] transition-all duration-300 cursor-default hover:-translate-y-0.5"
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = accent;
            e.currentTarget.style.boxShadow = `0 0 18px ${accent}33`;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "";
            e.currentTarget.style.boxShadow = "";
          }}
        >
          {zone}
        </span>
      ))}
    </div>
  </div>
);

export const Zones = () => (
  <section id="zone" data-testid="zones-section" className="py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <FadeUp>
        <Eyebrow>Zone di intervento</Eyebrow>
        <h1 className="font-display font-semibold tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-4 max-w-4xl">
          Roma, quartiere per quartiere.
          <span className="text-[#94A3B8]"> E tutta la provincia.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base md:text-lg text-[#94A3B8]">
          Interveniamo a domicilio in ogni quartiere di Roma e in tutti i comuni
          della provincia. Sei in una zona limitrofa non in elenco? Chiamaci:
          troviamo una soluzione.
        </p>
      </FadeUp>

      <div className="flex flex-col gap-16 mt-16">
        <FadeUp delay={0.1}>
          <AreaCloud
            title="Quartieri di Roma"
            icon={MapPin}
            accent="#FF6B00"
            items={ROMA_QUARTIERI}
            testId="roma-quartieri"
          />
        </FadeUp>
        <FadeUp delay={0.15}>
          <AreaCloud
            title="Comuni della provincia"
            icon={Building2}
            accent="#00D2FF"
            items={ZONES}
            testId="provincia-comuni"
          />
        </FadeUp>
      </div>
    </div>
  </section>
);
